// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Lock: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 54.1"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M42.5 21.7h-1.9v-4.3C40.6 8.2 33.1.7 23.9.7S7.3 8.2 7.3 17.4v4.3H5.5C3 21.7.9 23.8.9 26.3v22.6c0 2.5 2.1 4.6 4.6 4.6h37.1c2.5 0 4.6-2.1 4.6-4.6V26.3c-.1-2.6-2.1-4.6-4.7-4.6zm-32.4-4.3c0-7.7 6.3-13.9 13.9-13.9 7.7 0 13.9 6.3 13.9 13.9v4.3h-3.7v-4.3c0-5.6-4.6-10.2-10.2-10.2s-10.2 4.6-10.2 10.2v4.3h-3.7v-4.3zm21.4 4.3h-15v-4.3c0-4.1 3.4-7.5 7.5-7.5s7.5 3.4 7.5 7.5v4.3zm-26 2.7h37.1c1 0 1.9.8 1.9 1.9v9.9H3.6v-9.9c0-1.1.8-1.9 1.9-1.9zm38.9 14.5v3.7H3.6v-3.7h40.8zm-1.9 11.8h-37c-1 0-1.9-.8-1.9-1.9v-3.5h40.8v3.5c0 1.1-.8 1.9-1.9 1.9z"/></svg>;
};

export default React.memo(Lock);
